var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "template",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.609,
    height: 13.609,
    viewBox: "0 0 13.609 13.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M331,376h1.595v1.595H331Z",
    transform: "translate(-322.202 -366.006)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11247",
    "data-name": "Path 11247",
    d: "M121,376h3.19v1.595H121Z",
    transform: "translate(-117.784 -366.006)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11248",
    "data-name": "Path 11248",
    d: "M0,158.4a1.22,1.22,0,0,0,1.2,1.223H12.413a1.22,1.22,0,0,0,1.2-1.223V150H0Zm11.19-.4a.4.4,0,0,1-.4.4H8.4A.4.4,0,0,1,8,158v-2.392a.4.4,0,0,1,.4-.4h2.392a.4.4,0,0,1,.4.4Zm-8.771-6.379a.4.4,0,0,1,.4-.4h7.974a.4.4,0,0,1,.4.4v2.392a.4.4,0,0,1-.4.4H2.817a.4.4,0,0,1-.4-.4Zm0,3.987a.4.4,0,0,1,.4-.4H6.8a.4.4,0,0,1,.4.4V158a.4.4,0,0,1-.4.4H2.817a.4.4,0,0,1-.4-.4Z",
    transform: "translate(0 -146.013)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11249",
    "data-name": "Path 11249",
    d: "M121,226h7.177v1.595H121Z",
    transform: "translate(-117.784 -219.993)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11250",
    "data-name": "Path 11250",
    d: "M12.413,0H1.2A1.2,1.2,0,0,0,0,1.2V3.19H13.609V1.2A1.2,1.2,0,0,0,12.413,0Zm-9.6,1.993a.4.4,0,1,1,.4-.4A.4.4,0,0,1,2.817,1.993Zm1.595,0a.4.4,0,1,1,.4-.4A.4.4,0,0,1,4.412,1.993Zm1.595,0a.4.4,0,1,1,.4-.4A.4.4,0,0,1,6.007,1.993Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.0e7e2ac4ccd6825f4f6a756fa0d7c31b.svg";
export { ForwardRef as ReactComponent };